/**
 * Strips a favorite medication down to only the fields needed for AI prompt generation.
 */
export function slimMedication(med: any) {
  const {
    id,
    name,
    quantity,
    quantity_unit,
    route,
    refills,
    comments,
    prn,
    dosage,
    dosage_unit,
    frequency,
    time,
    time_unit,
    dosing_instructions,
    drugbank_product,
  } = med;

  return {
    id,
    name,
    quantity,
    quantity_unit,
    route,
    refills,
    comments,
    prn,
    dosage,
    dosage_unit,
    frequency,
    time,
    time_unit,
    dosing_instructions,
    ...(drugbank_product && {
      drugbank_product: {
        prescribable_name: drugbank_product.prescribable_name,
        dosage_form: drugbank_product.dosage_form,
        route: drugbank_product.route,
        schedule: drugbank_product.schedule,
        ingredients: drugbank_product.ingredients?.map((ing: any) => ({
          name: ing.name,
          strength: ing.strength,
        })),
      },
    }),
  };
}

/**
 * Whether a DrugBank `schedule` string denotes a CONTROLLED substance (under the
 * Controlled Drugs and Substances Act). DrugBank overloads the one `schedule`
 * field with two distinct Canadian taxonomies, so we must be precise:
 *   - CDSA scheduling = actually controlled — e.g. "CONTROLLED DRUGS (CDSA I)",
 *     "Narcotic (CDSA I)", "Targeted (CDSA IV)", "Schedule G (CDSA I)".
 *   - NAPRA scheduling = pharmacy-handling only — a bare "Schedule I" means
 *     prescription-only, NOT controlled.
 * So we match on the CDSA/narcotic/targeted/controlled markers and deliberately
 * do NOT match the bare word "Schedule" (which would false-positive on NAPRA
 * Schedule I prescription drugs).
 */
export function isControlledSchedule(schedule: string | undefined | null): boolean {
  if (!schedule) return false;
  return /\b(cdsa|narcotic|targeted|controlled)\b/i.test(schedule);
}
